import { useState } from 'react';

function loadJson(key) {
  try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch { return null; }
}

const LS_PINNED_FILES = 'rda_filehub_pinned_v2';

export function useFileHubPinned() {
  const [pinnedFiles, setPinnedFiles] = useState(() => loadJson(LS_PINNED_FILES) || {});

  return {
    pinnedFiles, setPinnedFiles,
  };
}
